import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const TabsRootContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") TabsRootContext.displayName = "TabsRootContext";
function useTabsRootContext() {
  const context = React.useContext(TabsRootContext);
  if (context === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : formatErrorMessage(64));
  }
  return context;
}
export {
  TabsRootContext,
  useTabsRootContext
};
//# sourceMappingURL=TabsRootContext.js.map
